export const VERSION = {
  PROD: 'V. 3.7.0',
  QA: 'V. 5.1.0 (QA)',
}
